import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import { ReactComponent as IconFolder } from "@/assets/svgs/package-folder-icon.svg";
import Button from '@/components/Button/index';
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import { ToastContext } from '@/context/toast/index';
import api from "@/services/api/packageFolder.js";
import rem from '@/utils/rem';
import { useContext, useState } from 'react';


export default function CreatePackageFolderModal({ visible, close }) {
	const [name, setName] = useState('')
	const [error, setError] = useState('')
	const [loading, setLoading] = useState(false)

	const { addToastMessage } = useContext(ToastContext);

	function handleClose() {
		setName('')
		close()
	}

	const validateFolderName = (name) => {
		let regex = /^[\w\-\s]+$/
		setError(
			regex.test(name)
				? ''
				: 'Please re-enter the text. Input field allows only Alphanumeric, Hyphen or Space as characters.',
		)
	}

	const handleCreateFolderSubmit = async () => {

		setLoading(true)
		const [error] = await api.createFolder({ name });
		setLoading(false)

		if (error) {
			handleClose()
			return addToastMessage('Failed to create a folder', 'error')
		}

		handleClose()
		document.getElementById('reload-eclips')?.click();
		return addToastMessage('You have successfully created a folder.', 'success')
	}


	return (
		<Modal visible={visible} variant='medium'  close={handleClose}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon--package'}>
										<IconFolder />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Creating New Folder
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="package-landing__create-folder__content">
							<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span">
								Name of Folder
							</span>
							<input
								type="text"
								onChange={(e) => {
									setName(e.target.value)
									validateFolderName(e.target.value)
								}}
								value={name}
								maxLength={42}
								placeholder="Name of Folder"
							/>
							<div className="package-landing__error-text">
								{error && name !== '' && (
									<div className="folder-name-err-msg">{error}</div>
								)}
							</div>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={handleClose} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
							text="Confirm"
							loading={loading}
							disabled={loading || name === '' || error !== ''}
							submit={handleCreateFolderSubmit}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
